import React, { useEffect, useRef, useState } from "react";
import bodymovin from "bodymovin";

import { useGlobalState } from "../components/GlobalStateProvider";

import AnimatedStep from "./AnimatedStep";

import * as Styles from "./Step.styles";

let firstAnim = null;
let secondAnim = null;

const Step3 = () => {
  const { globalState, setGlobalState } = useGlobalState();
  const [isLoadingFinalMoment, setIsLoadingFinalMoment] = useState(false);
  const [isFinalMoment, setIsFinalMoment] = useState(false);
  const [songInput, setSongInput] = useState("");
  const [stage, setStage] = useState(1);

  const counterRef = useRef(null);
  const animContainerRef = useRef(null);

  const star1Ref = useRef(null);
  const star2Ref = useRef(null);

  let lottie = null;

  const handleFinalClick = () => {
    setIsFinalMoment(true);
    setIsLoadingFinalMoment(true);

    setTimeout(() => {
      setStage(2);
    }, 5000);

    setTimeout(() => {
      setStage(3);
    }, 12000);

    setTimeout(() => {
      setStage(4);
    }, 18000);

    const prompt = `Generate ${globalState.genre} song lyrics about ${globalState.description} inspired by ${songInput}. Lyrics shouldn't be longer than 400 tokens`;

    fetch(`https://www.airocke.rocks/get_completion?prompt=${prompt}`)
    // fetch(`http://127.0.0.1:5000/get_completion?prompt=${prompt}`)
      .then(response => response.json())
      .then(data => {
        setGlobalState({ ...globalState, song: data.completion });

        setIsLoadingFinalMoment(false);

        bodymovin
          .loadAnimation({
            container: counterRef.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            name: "final-anim1",
            path: "/animations/counter.json",
          })
          .setSpeed(1);

          setTimeout(() => {
            setGlobalState({ ...globalState, isFinalAnimation: true, artist: songInput, song: data.completion });
          }, 2800);

          setTimeout(() => {
            setIsFinalMoment(false);
            setGlobalState({
              ...globalState,
              position: globalState.position + 1,
              isFinalAnimation: true,
              song: data.completion
            });
          }, 3000);
      });
  };

  const handleMouseOver = (event) => {
    bodymovin
      .loadAnimation({
        container: animContainerRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        name: "star-background",
        path: "/animations/finalButton.json",
      })
      .setSpeed(2);

    bodymovin
      .loadAnimation({
        container: animContainerRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        name: "star-background2",
        path: "/animations/finalNotes.json",
      })
      .setSpeed(2);
  };

  const handleMouseLeave = () => {
    bodymovin.destroy("star-background");
    bodymovin.destroy("star-background2");
  };

  useEffect(() => {
    if (star1Ref.current && !lottie && firstAnim !== undefined) {
      firstAnim = bodymovin
        .loadAnimation({
          container: star1Ref.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          name: "note-two",
          path: "/animations/note-two.json",
        })
        .setSpeed(1);
    }

    if (star2Ref.current && !lottie && secondAnim !== undefined) {
      secondAnim = bodymovin
        .loadAnimation({
          container: star2Ref.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          name: "note-one",
          path: "/animations/note-one.json",
        })
        .setSpeed(1);
    }
  }, [star1Ref, lottie]);

  return (
    <Styles.Wrapper
      initial={{ x: 50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -50, opacity: 0 }}
      transition={{ duration: 0.5 }}
      key="step3"
    >
      <Styles.ArrowRow>
        <Styles.ArrowBack
          onClick={() =>
            setGlobalState({
              ...globalState,
              position: globalState.position - 1,
            })
          }>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.6665 18.3334L21.1665 16.8334C21.4721 16.5279 21.6248 16.139 21.6248 15.6667C21.6248 15.1945 21.4721 14.8056 21.1665 14.5001C20.861 14.1945 20.4721 14.0417 19.9998 14.0417C19.5276 14.0417 19.1387 14.1945 18.8332 14.5001L14.4998 18.8334C14.1665 19.1667 13.9998 19.5556 13.9998 20.0001C13.9998 20.4445 14.1665 20.8334 14.4998 21.1667L18.8332 25.5001C19.1387 25.8056 19.5276 25.9584 19.9998 25.9584C20.4721 25.9584 20.8609 25.8056 21.1665 25.5001C21.4721 25.1945 21.6248 24.8056 21.6248 24.3334C21.6248 23.8612 21.4721 23.4723 21.1665 23.1667L19.6665 21.6667L24.9998 21.6667C25.4721 21.6667 25.8682 21.5067 26.1882 21.1867C26.5082 20.8667 26.6676 20.4712 26.6665 20.0001C26.6665 19.5279 26.5065 19.1317 26.1865 18.8117C25.8665 18.4917 25.4709 18.3323 24.9998 18.3334L19.6665 18.3334ZM19.9998 3.33341C22.3054 3.33341 24.4721 3.77119 26.4998 4.64675C28.5276 5.5223 30.2915 6.70953 31.7915 8.20841C33.2915 9.70841 34.4787 11.4723 35.3532 13.5001C36.2276 15.5279 36.6654 17.6945 36.6665 20.0001C36.6665 22.3056 36.2287 24.4723 35.3532 26.5001C34.4776 28.5279 33.2904 30.2917 31.7915 31.7917C30.2915 33.2917 28.5276 34.479 26.4998 35.3534C24.4721 36.2279 22.3054 36.6656 19.9998 36.6667C17.6943 36.6667 15.5276 36.229 13.4998 35.3534C11.4721 34.4779 9.70817 33.2906 8.20817 31.7917C6.70817 30.2917 5.5204 28.5279 4.64484 26.5001C3.76928 24.4723 3.33206 22.3056 3.33317 20.0001C3.33317 17.6945 3.77095 15.5279 4.64651 13.5001C5.52206 11.4723 6.70928 9.70841 8.20817 8.20841C9.70817 6.70841 11.4721 5.52064 13.4998 4.64508C15.5276 3.76953 17.6943 3.3323 19.9998 3.33341ZM19.9998 6.66675C16.2776 6.66675 13.1248 7.95841 10.5415 10.5417C7.95817 13.1251 6.66651 16.2779 6.66651 20.0001C6.66651 23.7223 7.95817 26.8751 10.5415 29.4584C13.1248 32.0417 16.2776 33.3334 19.9998 33.3334C23.7221 33.3334 26.8748 32.0417 29.4582 29.4584C32.0415 26.8751 33.3332 23.7223 33.3332 20.0001C33.3332 16.2779 32.0415 13.1251 29.4582 10.5417C26.8748 7.95842 23.7221 6.66675 19.9998 6.66675Z" fill="white"/>
          </svg>
        </Styles.ArrowBack>
      </Styles.ArrowRow>

      <AnimatedStep step="3" />

      <Styles.FinalMomentWrapper isLive={isFinalMoment} ref={counterRef}>
        <Styles.FinalMomentLoader isLive={isLoadingFinalMoment}>
          <Styles.Note1 ref={star1Ref} />
          {stage === 1 && <>Generating your song</>}
          {stage === 2 && <>Receiving classified data</>}
          {stage === 3 && <>THANK YOU AI!</>}
          {stage === 4 && <>Rendering Lyrics - ENJOY!</>}
          <Styles.Note2 ref={star2Ref} />
        </Styles.FinalMomentLoader>
      </Styles.FinalMomentWrapper>

      <Styles.Title>Inspired by:</Styles.Title>
      <Styles.Hint>max. 150 characters (e.g Prince, Metallica)</Styles.Hint>
      <Styles.Input
        autoFocus
        value={songInput}
        maxLength="150"
        placeholder="Band/Artist"
        onInput={(e) => setSongInput(e.target.value)}
      />
      <Styles.RedCTA
        onMouseEnter={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onClick={handleFinalClick}
        disabled={songInput.length === 0}
      >
        <div disabled={songInput.length === 0}>ROCK IT</div>
        <Styles.CTAanimContainer ref={animContainerRef} />
      </Styles.RedCTA>
    </Styles.Wrapper>
  );
};

export default Step3;
